/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension" DataTable endpoint.
 * Fetches user-authored creative variants for one semantic dimension and returns them
 * in the standard DataTable format ({ hits, results }).
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension } from "./constants";
import type {
  DecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionParams,
  GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult,
  RawCreativeVariantsResponse,
} from "./types";
import { isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult } from "./validators";

export const getDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension =
  reactQueryTableFetcherAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimension,
    async (
      signal: AbortSignal,
      {
        appGroupId,
        dsaId,
        dimension,
        limit,
        start = 0,
        query,
      }: DecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionParams
    ): Promise<GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult> => {
      const rawResponse = await fetch<RawCreativeVariantsResponse>(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/creative_variants/dimensions/${dimension}`,
        "GET",
        { start, limit, search_term: query?.search_term },
        { signal }
      );

      return {
        hits: rawResponse.hits,
        results: rawResponse.results.map((item) => ({
          id: String(item.actionId),
          creative: item.creative,
          compatibleBaseCreativeCampaignIds: item.compatibleBaseCreativeCampaignIds,
        })),
      };
    },
    isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult
  );
